
















import {Component, Ref, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
     * This component MUST come as the innermost stack among the other providers, to ensure portal targets
     * still obtain injected values such as locale.
     *
     * Partially deprecated; use simple-portal whenever possible, when you need global-level teleports.
     *
     * @status stable
     * @published 4.0.0
     * @changelog 4.0.0 Published.
     * @changelog 4.6.0 Remove portal targets that were replaced with simple-portal.
     */
    @Component
    export default class JdsTeleportProvider extends Vue {
        @ActiveProvide('jds.teleport-provider.bus') bus!: Vue|null = null
        @Ref() mainEl!: HTMLElement
        @Ref() globalEl!: HTMLElement

        beforeMount() {
            this.bus = new Vue()
            this.bus.$on('inert', () => {this.mainEl.inert = true})
            this.bus.$on('de-inert', () => {this.mainEl.inert = false})

            // use these for when you're using simple-vue-portal.
            this.bus.$on('global-inert', () => {this.globalEl.inert = true})
            this.bus.$on('global-de-inert', () => {this.globalEl.inert = false})
        }
    }
